import { checkAuth } from '@/services/auth'

import Index from '@/views/push-notifications/Index'

export default [
    {
        path: '/push-notifications',
        name: 'pushNotificationsAdmin',
        component: Index,
        beforeEnter(to, from, next) {
            checkAuth().then(response => {
                if (response) {
                    next()
                } else {
                    next('/login')
                }
            })
        }
    },
]
